import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  Grid,
  Button,
  Select,
  ListItem,
  List,
  useMediaQuery,
  useTheme,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Popover,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormHelperText,
  FormControl,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ChatIcon from "@material-ui/icons/Chat";
import CastForEducationIcon from "@material-ui/icons/CastForEducation";
import { ReactComponent as Support } from "../images/support.svg";
import CloseIcon from "@material-ui/icons/Close";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AddIcon from "@material-ui/icons/Add";

import { searchDataArray } from "./../components/searchDataArray";
import Slider from "../components/Slider";
import divisions from "../divisions.json";
import ChoiceProperty from "./ChoiceProperty";

export default function HomePage() {
  const [searchData, setSearchData] = useState();
  const [search, setSearch] = useState(false);
  const props = {
    search,
    setSearch,
    searchData,
    setSearchData,
  };
  //隱藏
  return (
    <Box>
      <Introduction />
      <FindBestPlace props={props} />
      <ChoiceProperty />
      <New />
      {/* Franchisee = 加盟 */}
      {/* <Franchisee /> */}
      <FranchiseePhone />
      <HotKey />
    </Box>
  );
}

//ANCHOR 簡介
function Introduction() {
  const history = useHistory();
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    backImg: {
      margin: "0 auto",
      position: isTable ? "absolute" : "",
      display: isTable ? "none" : "",
      zIndex: -1,
    },
    imgTextBox: {
      position: "absolute",
      top: "50%",
      left: "10%",
      transform: "translateY(-50%)",
      width: "30%",
      display: isTable ? "none" : "",
    },
    textBoxPc: {
      position: "absolute",
      bottom: "7%",
      left: "8.5%",
      color: theme.palette.primary.light,
      display: isTable ? "none" : "block",
    },
    textBox: {
      color: theme.palette.secondary.light,
      display: isTable ? "block" : "none",
    },
    introductionImg: {
      position: isTable ? "" : "absolute",
      right: 0,
      top: "60%",
      transform: isTable ? "" : "translateY(-50%)",
      right: "7%",
      width: isTable ? "100%" : "30%",
      margin: isTable ? "4em 0 2em 0" : "",
    },
  }));
  const classes = useStyles();

  return (
    <Box>
      <Box position="relative">
        <img
          src="/assets/images/Home/introduction.png"
          className={classes.backImg}
        />
        <Box className={classes.imgTextBox}>
          <img
            src="/assets/images/Home/introduction1.png"
            className={classes.introductionImgText}
          />
        </Box>
        <Box className={classes.textBoxPc}>
          <Container maxWidth="lg">
            <Typography variant="h6">富屋法拍屋，法拍業界的領導品牌</Typography>
            <Typography variant="h6" gutterBottom>
              全國第一通過ISO9001國際品質標準認證!
            </Typography>
            <Typography variant="h6" gutterBottom>
              買法拍找富屋，金拍屋、銀拍屋、富屋法拍屋。
            </Typography>
            <Button onClick={() => history.push("./brand-story")}>
              <Typography
                variant="h6"
                style={{ color: theme.palette.primary.light }}
              >
                了解富屋 &gt;&gt;
              </Typography>
            </Button>
          </Container>
        </Box>
        <Container maxWidth="lg">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            {/* Note 暫時換成影片 */}
            {/* <Box className={classes.introductionImg}>
              <img
                src="/assets/images/Home/introduction2.jpg"
                style={{ objectFit: "fill", width: isTable ? "100%" : "" }}
              />
            </Box> */}

            <Box
              mt={isTable ? 4 : 6}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
              className={classes.introductionImg}
            >
              {/* <Typography varaint="body1" align="center">
                中文版
              </Typography> */}
              <Box mt={isTable ? 4 : 5}>
                <iframe
                  width={isTable ? (isPhone ? "300" : "400") : "450"}
                  height={isTable ? (isPhone ? "300" : "400") : "450"}
                  src="https://www.youtube.com/embed/hv5NfkV_Q78?rel=0&autoplay=1&loop=1&playlist=hv5NfkV_Q78&amp;showinfo=0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                  allowfullscreen
                  style={{ borderRadius: "10px" }}
                ></iframe>
              </Box>
            </Box>
            {/* 文字 Table、Phone .. */}
            <Box className={classes.textBox}>
              <Container maxWidth="lg">
                <Typography variant="body1">
                  富屋法拍屋，法拍業界的領導品牌，
                </Typography>
                <Typography variant="body1" gutterBottom>
                  全國第一通過ISO9001國際品質標準認證!
                </Typography>
                <Typography variant="body1" gutterBottom>
                  買法拍找富屋，金拍屋、銀拍屋、富屋法拍屋。
                </Typography>
                <Button onClick={() => history.push("./brand-story")}>
                  <Typography
                    variant="body1"
                    style={{ color: theme.palette.secondary.light }}
                  >
                    了解富屋 &gt;&gt;
                  </Typography>
                </Button>
              </Container>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

//ANCHOR 找尋頭資最佳地點
function FindBestPlace({ props }) {
  let city = Object.keys(divisions);
  const isTable = useMediaQuery("(min-width:769px)");
  const isPhone = useMediaQuery("(max-width:576px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100vh",
      minHeight: "650px",
    },
    backImg: {
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    contentBox: {
      justifyContent: "center",
      "& .MuiTypography-h2": {
        fontSize: isTable ? "4.5rem" : "2.25rem",
        textAlign: "center",
        color: "white",
        fontWeight: "bold",
        marginBottom: "60px",
      },
      "& .MuiTypography-h4": {
        color: "white",
        fontWeight: "lighter",
        marginBottom: "60px",
        textAlign: "center",
      },
    },
    selectBox: {
      backgroundColor: "white",
      height: "70px",
      borderRadius: "35px",
      marginBottom: "60px",
      width: "100%",
      // select 倒三角形
      "& .MuiSvgIcon-root": {
        right: "-30%",
        top: "50%",
        transform: "translateY(-50%)",
      },
    },
    selectGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRight: "1px solid rgba(0,0,0,0.6)",
      width: "100%",
      height: "100%",
      paddingRight: isPhone ? "1em" : "",
    },
    select: {
      backgroundColor: "transparent",
      fontSize: isPhone ? "1rem" : "1.25rem",
      height: "70px",
      "&.MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
      "&.MuiSelect-root": {
        margin: "0",
      },
      "&.MuiSelect-select.MuiSelect-select": {
        padding: "0",
      },
    },
    buttonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    button: {
      backgroundColor: theme.palette.secondary.light,
      width: isTable ? `calc((100vw/12)*2.5)` : "250px",
      height: isTable ? "60px" : "40px",
      borderRadius: isTable ? "30px" : "20px",
      fontSize: "1.5rem",
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
  }));
  const classes = useStyles();
  return (
    <Box mt={4} className={classes.backBox}>
      <img
        src="/assets/images/Home/findBestPlace.png"
        className={classes.backImg}
      />
      <Grid
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Grid container item xs={12} lg={10} className={classes.contentBox}>
          {/* ANCHOR查詢 這裡 */}
          <Grid xs={12} container item>
            <Grid xs={12} item>
              <SearchForm props={props} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

//ANCHOR 最新消息
function New() {
  const isPhone = useMediaQuery("(min-width:375px)");
  const isTable = useMediaQuery("(min-width:769px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      height: "100%",
    },
    title: {
      position: "relative",
      width: "100%",
      height: "200px",
      background: 'url("/assets/images/Home/newback2.png") 100% 100%',
    },
    titleImg: {
      position: "absolute",
      top: "50%",
      left: "49%",
      transform: "translate( -50%, -20%)",
      objectFit: "cover",
      minWidth: "300px",
      width: isTable ? "600px" : isPhone ? "350px" : "300px",
    },
    titleText: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate( -50%, -20%)",
      textAlign: "center",
      "& .MuiTypography-h4": {
        color: "white",
        fontWeight: "bold",
        marginBottom: "30px",
      },
      "& .MuiTypography-subtitle1": {
        color: "white",
      },
    },
  }));
  const classes = useStyles();

  const imgArray = [
    "/assets/images/Home/introduction2.jpg",
    "/assets/images/Home/new1.jpg",
    "/assets/images/Home/new2.png",
    "/assets/images/Home/new3.png",
    "/assets/images/Home/new4.png",
  ];

  return (
    <Box className={classes.backBox}>
      <Grid className={classes.title}>
        <img
          src="/assets/images/Home/newback.png"
          className={classes.titleImg}
        />
        <Grid className={classes.titleText}>
          <Typography variant="h4">NEWS</Typography>
          <Typography variant="subtitle1">最新消息</Typography>
        </Grid>
      </Grid>
      <Grid style={{ height: "600px" }}>
        <Slider props={imgArray} />
      </Grid>
    </Box>
  );
}

//ANCHOR 加盟店
function Franchisee() {
  const isPhone = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    backBox: {
      height: "100%",
      marginBottom: "50px",
    },
    title: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "50px",
      "& .MuiTypography-subtitle1": {
        color: "white",
        textAlign: "center",
        padding: "0px 10px",
      },
    },
    titleText: {
      backgroundColor: theme.palette.secondary.light,
      height: "50px",
      display: "flex",
      alignItems: "center",
    },
    more: {
      color: theme.palette.secondary.light,
    },
    listTitle: {
      fontWeight: "bold",
      marginTop: "50px",
      marginBottom: "20px",
      color: theme.palette.secondary.light,
    },
    list: {
      justifyContent: "space-between",
      padding: "8px 0px",
      borderTop: "1px solid",
      borderColor: theme.palette.secondary.light,
      "& span": {
        marginLeft: "10px",
        color: theme.palette.secondary.light,
      },
    },
  }));
  const classes = useStyles();

  const franchiseeArray = [
    "總店",
    "員林店",
    "北市加盟店",
    "台北內湖店",
    "陽明店",
    "上榕店",
    "仁杰店",
    "北灣店",
    "好康加盟店",
  ];
  return (
    <Box className={classes.backBox}>
      <Container maxWidth="lg">
        <Grid
          container
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item lg={10}>
            <Grid item lg={12} className={classes.title}>
              <Grid className={classes.titleText}>
                <Typography variant="subtitle1">全台加盟店資訊</Typography>
              </Grid>
              <Grid>
                <Button className={classes.more}>查看更多加盟店&gt;&gt;</Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={10}
            justify={isPhone ? "center" : "space-between"}
          >
            <Grid item xs={12} md={3}>
              <Typography variant="h4" className={classes.listTitle}>
                北部
              </Typography>
              <List>
                {franchiseeArray.map((item) => {
                  return (
                    <Box style={{ color: theme.palette.grey[700] }}>
                      <ListItem button className={classes.list}>
                        <Typography variant="subtitle1">{item}</Typography>
                        <Typography variant="subtitle1">
                          立刻前往<span>&gt;</span>
                        </Typography>
                      </ListItem>
                    </Box>
                  );
                })}
              </List>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography variant="h4" className={classes.listTitle}>
                中部
              </Typography>
              <List>
                {franchiseeArray.map((item) => {
                  return (
                    <Box style={{ color: theme.palette.grey[700] }}>
                      <ListItem button className={classes.list}>
                        <Typography variant="subtitle1">{item}</Typography>
                        <Typography variant="subtitle1">
                          立刻前往<span>&gt;</span>
                        </Typography>
                      </ListItem>
                    </Box>
                  );
                })}
              </List>
            </Grid>
            <Grid xs={12} item md={3}>
              <Typography variant="h4" className={classes.listTitle}>
                南部
              </Typography>
              <List>
                {franchiseeArray.map((item) => {
                  return (
                    <Box style={{ color: theme.palette.grey[700] }}>
                      <ListItem button className={classes.list}>
                        <Typography variant="subtitle1">{item}</Typography>
                        <Typography variant="subtitle1">
                          立刻前往<span>&gt;</span>
                        </Typography>
                      </ListItem>
                    </Box>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

//ANCHOR 加盟專線
function FranchiseePhone() {
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      display: "flex",
      alignItems: "center",
      height: "30vh",
      minHeight: "300px",
      background: 'url("/assets/images/Home/franchiseePhone.png") 100%',
      "& .MuiTypography-h5": {
        color: "white",
      },
      "& .MuiTypography-subtitle2": {
        color: "white",
      },
    },
    backImg: {
      width: "100%",
      height: "100%",
    },
  }));
  const classes = useStyles();

  return (
    <Box className={classes.backBox}>
      <Box width="100%" pl={isPhone ? 3 : 15}>
        <Grid container>
          <Grid item xs={12}>
            <Box mb={2}>
              <Typography variant="h5">加盟專線</Typography>
              <Typography variant="h5">0800-800-680</Typography>
            </Box>
          </Grid>
          <Grid container item xs={12} spacing={isPhone ? 1 : 4}>
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                台中市南屯區大英西一街61號
              </Typography>
              <Typography variant="subtitle2">電話:(04)2471-7673</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2">傳真(04)2473-3106</Typography>
              <Typography variant="subtitle2">客服中心(04)2472-0443</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

//ANCHOR 快捷鍵
function HotKey() {
  const history = useHistory();
  const useStyles = makeStyles((theme) => ({
    collapse: {
      backgroundColor: theme.palette.secondary.light,
      width: "65px",
      color: "white",
      borderRadius: "10px 0px 0px 10px",
    },
    popover: {
      pointerEvents: "none",
    },
    paper: {
      padding: theme.spacing(1),
    },
    directionRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    // table
    table: {
      width: "100%",
      minWidth: "900px",
      "& th": {
        padding: "5px 3px",
        border: "1px solid grey",
        whiteSpace: "nowrap",
      },
      "& td": {
        padding: "5px 3px",
        border: "1px solid grey",
      },
    },
  }));
  const classes = useStyles();
  const btnList = [
    {
      name: <NotificationsIcon />,
      label: "資訊訂閱",
      href: "./",
    },
    {
      name: <CastForEducationIcon />,
      label: "最新課程",
      href: "./",
    },
    {
      name: <ChatIcon />,
      label: "留言板",
      href: "/consultation",
    },
    {
      name: <Support />,
      label: "客服小幫手",
      href: "https://line.me/R/ti/p/%40165tntpk",
    },
    {
      name: <AttachMoneyIcon />,
      label: "試算工具",
      href: "",
    },
  ];

  const calculateList = ["按月平均攤還本息試算", "按月平均攤還本金試算"];
  //TODO
  const { control, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      selectCalculate: "按月平均攤還本息試算",
      anchorEl: null,
      label: "",
      open: false,
      loan: "",
      interestRate: "",
      deadline: "",
      gracePeriod: "",
      discount: [],
      result: false,
      arrayLength: [],
    },
  });
  // const { control, handleSubmit, setValue, reset } = useForm({
  //   defaultValues: {
  //     selectCalculate: "按月平均攤還本息試算",
  //     anchorEl: null,
  //     label: "",
  //     open: false,
  //     loan: "10000",
  //     interestRate: "10",
  //     deadline: "12",
  //     gracePeriod: "2",
  //     discount: [],
  //     result: false,
  //     arrayLength: [],
  //   },
  // });
  const {
    fields: discountFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "discount",
  });
  const interestRate = useWatch({ control, name: "interestRate" });
  const loan = useWatch({ control, name: "loan" });
  const deadline = useWatch({ control, name: "deadline" });
  const anchorEl = useWatch({ control, name: "anchorEl" });
  const label = useWatch({ control, name: "label" });
  const open = useWatch({ control, name: "open" });
  const selectCalculate = useWatch({ control, name: "selectCalculate" });
  const result = useWatch({ control, name: "result" });
  const arrayLength = useWatch({ control, name: "arrayLength" });
  const gracePeriod = useWatch({ control, name: "gracePeriod" });
  let currentLoan;
  let totalInterest = 0;
  const handlePopoverOpen = (event, label) => {
    setValue("anchorEl", event.currentTarget);
    setValue("label", label);
  };

  const handlePopoverClose = () => {
    setValue("anchorEl", null);
  };

  const onClose = () => {
    reset({
      selectCalculate: "按月平均攤還本息試算",
      anchorEl: null,
      label: "",
      open: false,
      loan: "",
      interestRate: "",
      deadline: "",
      gracePeriod: "",
      discount: [],
      result: false,
      arrayLength: [],
    });
  };

  const popoverOpen = Boolean(anchorEl);

  function _result(data) {
    setValue("result", true);
    const newArrayLength = [];
    let discountLength = [];
    let totalDiscountDuring = 0;
    let currentGracePeriod = Number(data.gracePeriod);
    if (data.discount.length > 0) {
      data.discount.forEach((item) => {
        discountLength = [];
        totalDiscountDuring += Number(item.during);
        for (let index = 0; index < Number(item.during); index++) {
          if (currentGracePeriod > 0)
            discountLength.push({ gracePeriod: true });
          else discountLength.push({});

          currentGracePeriod = currentGracePeriod - 1;
        }
        newArrayLength.push({
          interestRate: item.interestRate,
          data: discountLength,
        });
      });
      discountLength = [];
      for (
        let index = 0;
        index < Number(deadline) - totalDiscountDuring;
        index++
      ) {
        if (currentGracePeriod > 0) discountLength.push({ gracePeriod: true });
        else discountLength.push({});

        currentGracePeriod = currentGracePeriod - 1;
      }
      newArrayLength.push({ interestRate, data: discountLength });
    } else {
      for (let index = 0; index < Number(deadline); index++) {
        newArrayLength.push({});
      }
    }
    setValue("arrayLength", newArrayLength);
  }

  useEffect(() => {
    setValue("result", false);
    setValue("arrayLength", []);
  }, [
    interestRate,
    loan,
    deadline,
    selectCalculate,
    discountFields,
    gracePeriod,
  ]);

  return (
    <Grid
      style={{
        display: "flex",
        position: "fixed",
        top: "40vh",
        right: "0px",
        zIndex: 10,
      }}
    >
      <Grid className={classes.collapse}>
        <Grid>
          {btnList.map((item, index) => (
            <Button
              key={index}
              fullWidth
              style={{ height: "65px", color: "white" }}
              href={item.href}
              onMouseEnter={(e) => handlePopoverOpen(e, item.label)}
              onMouseLeave={handlePopoverClose}
              onClick={() => {
                if (index === 4) setValue("open", true);
              }}
            >
              {item.name}
            </Button>
          ))}
        </Grid>
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={popoverOpen}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>{label}</Typography>
        </Popover>
        <Dialog open={open} fullWidth maxWidth="md">
          <DialogTitle>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <IconButton onClick={onClose} size="small">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item>試算工具</Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={1} style={{ marginBottom: "12px" }}>
              <Controller
                name="selectCalculate"
                control={control}
                rules={{
                  validate: (v) => {
                    if (!v) return "請輸入計算類型";
                  },
                }}
                render={({ field, fieldState: { error } }) =>
                  calculateList.map((item) => (
                    <Grid item>
                      <Button
                        color="primary"
                        variant={
                          item === selectCalculate ? "contained" : "outlined"
                        }
                        onClick={() => {
                          field.onChange(item);
                        }}
                      >
                        {item}
                      </Button>
                      <Typography style={{ color: "red" }}>
                        {error?.message}
                      </Typography>
                    </Grid>
                  ))
                }
              />
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} classes={{ root: classes.directionRow }}>
                <Controller
                  name="loan"
                  control={control}
                  rules={{
                    required: "請輸入貸款金額",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Typography>貸款金額：</Typography>
                      <TextField
                        {...field}
                        error={error}
                        helperText={error?.message}
                      />
                      <Typography>元</Typography>
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={6} classes={{ root: classes.directionRow }}>
                <Controller
                  name="interestRate"
                  control={control}
                  rules={{
                    required: "請輸入貸款利率",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Typography>貸款利率：</Typography>
                      <TextField
                        {...field}
                        error={error}
                        helperText={error?.message}
                      />
                      <Typography>％</Typography>
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={6} classes={{ root: classes.directionRow }}>
                <Controller
                  name="deadline"
                  control={control}
                  rules={{
                    required: "請輸入貸款期限",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Typography>貸款期限：</Typography>
                      <TextField
                        {...field}
                        error={error}
                        helperText={error?.message}
                      />
                      <Typography>個月</Typography>
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={6} classes={{ root: classes.directionRow }}>
                <Controller
                  name="gracePeriod"
                  control={control}
                  rules={{
                    validate: (v) => {
                      if (Number(v) > Number(deadline))
                        return "寬限期須小於貸款期限";
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Typography>寬限期：</Typography>
                      <TextField
                        {...field}
                        placeholder="非必填"
                        error={error}
                        helperText={error?.message}
                      />
                      <Typography>個月</Typography>
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={10}>
                <Typography>優惠利率：</Typography>
                {discountFields?.map((_, index) => (
                  <Grid container spacing={1}>
                    <Grid item classes={{ root: classes.directionRow }}>
                      <Typography variant="body2">
                        {`${index + 1}.　利率：`}
                      </Typography>
                      <Controller
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            {...field}
                            error={error}
                            helperText={error?.message}
                          />
                        )}
                        name={`discount.${index}.interestRate`}
                        control={control}
                        rules={{
                          required: "請輸入優惠利率",
                        }}
                      />
                      <Typography variant="body2">％</Typography>
                    </Grid>
                    <Grid item classes={{ root: classes.directionRow }}>
                      <Typography variant="body2">{"期間"}</Typography>
                      <Controller
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            {...field}
                            error={error}
                            helperText={error?.message}
                          />
                        )}
                        name={`discount.${index}.during`}
                        control={control}
                        rules={{
                          required: "請輸入優惠時間",
                        }}
                      />
                      <Typography variant="body2">{"個月"}</Typography>
                    </Grid>
                    <Grid item style={{ alignSelf: "center" }}>
                      <IconButton onClick={() => remove(index)} size="small">
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={2}>
                <Box display="flex" style={{ marginTop: "1rem" }}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      append({
                        interestRate: null,
                        during: null,
                      });
                    }}
                  >
                    新增
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={1} justifyContent="center">
              <Grid item>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(_result)}
                >
                  試算
                </Button>
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    reset({
                      open: true,
                      loan: "",
                      interestRate: "",
                      deadline: "",
                      gracePeriod: "",
                      discount: [],
                      result: false,
                      arrayLength: [],
                    });
                  }}
                >
                  清除
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
          {result && (
            <DialogContent dividers>
              <TableContainer component={Paper}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell align={"center"}>期次</TableCell>
                      <TableCell align={"center"}>應攤還本金</TableCell>
                      <TableCell align={"center"}>應攤還利息</TableCell>
                      <TableCell align={"center"}>本息合計</TableCell>
                      <TableCell align={"center"}>貸款餘額</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(() => {
                      if (selectCalculate === "按月平均攤還本金試算") {
                        if (
                          Number(gracePeriod) === 0 &&
                          discountFields.length === 0
                        ) {
                          return arrayLength?.map((_, index) => {
                            const last = index + 1 === arrayLength.length;
                            if (index === 0) currentLoan = loan;
                            const currentPrincipal = Math.round(
                              loan / deadline
                            );

                            const currentInterest = Math.round(
                              (currentLoan / deadline) * (interestRate / 100)
                            );
                            totalInterest += currentInterest;
                            const currentRepayment = last
                              ? currentLoan + currentInterest
                              : currentPrincipal + currentInterest;
                            if (!last)
                              currentLoan = currentLoan - currentPrincipal;
                            return (
                              <TableRow>
                                <TableCell align={"center"}>
                                  {index + 1}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {last ? currentLoan : currentPrincipal}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentInterest}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentRepayment}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {last ? 0 : currentLoan}
                                </TableCell>
                              </TableRow>
                            );
                          });
                        } else if (
                          Number(gracePeriod) !== 0 &&
                          discountFields.length === 0
                        ) {
                          return arrayLength?.map((_, index) => {
                            const graceDuring =
                              index + 1 <= Number(gracePeriod);
                            if (graceDuring) currentLoan = loan;
                            const currentPrincipal = graceDuring
                              ? 0
                              : Math.round(
                                  loan /
                                    (Number(deadline) - Number(gracePeriod))
                                );

                            const currentInterest = Math.round(
                              (currentLoan / deadline) * (interestRate / 100)
                            );
                            totalInterest += currentInterest;
                            const currentRepayment =
                              currentPrincipal + currentInterest;

                            currentLoan = currentLoan - currentPrincipal;
                            return (
                              <TableRow>
                                <TableCell align={"center"}>
                                  {index + 1}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {graceDuring ? 0 : currentPrincipal}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentInterest}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentRepayment}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {graceDuring ? loan : currentLoan}
                                </TableCell>
                              </TableRow>
                            );
                          });
                        } else if (discountFields.length > 0) {
                          currentLoan = loan;
                          let duringArray = [];
                          let totalLength = 0;
                          arrayLength.forEach((item) => {
                            totalLength += item.data?.length;
                          });
                          for (let index = 1; index <= totalLength; index++) {
                            duringArray.push(index);
                          }
                          return arrayLength?.map((item, index) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell
                                    align={"center"}
                                    colSpan={5}
                                    style={{
                                      color: "white",
                                      backgroundColor: "#103775",
                                    }}
                                  >
                                    {`以下利率為${item.interestRate}%`}
                                  </TableCell>
                                </TableRow>
                                {item.data?.map((item2, index2) => {
                                  const graceDuring = item2.gracePeriod;
                                  let period = null;
                                  period = duringArray.shift();
                                  if (graceDuring) currentLoan = loan;
                                  const currentPrincipal = graceDuring
                                    ? 0
                                    : Math.round(
                                        loan /
                                          (Number(deadline) -
                                            Number(gracePeriod))
                                      );

                                  const currentInterest = Math.round(
                                    (currentLoan / deadline) *
                                      (Number(item.interestRate) / 100)
                                  );
                                  totalInterest += currentInterest;
                                  const currentRepayment =
                                    duringArray.length === 0
                                      ? currentLoan + currentInterest
                                      : currentPrincipal + currentInterest;
                                  if (duringArray.length !== 0) {
                                    currentLoan =
                                      currentLoan - currentPrincipal;
                                  }

                                  return (
                                    <TableRow>
                                      <TableCell align={"center"}>
                                        {period}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {graceDuring
                                          ? 0
                                          : duringArray.length === 0
                                          ? currentLoan
                                          : currentPrincipal}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {currentInterest}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {currentRepayment}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {graceDuring
                                          ? loan
                                          : duringArray.length === 0
                                          ? 0
                                          : currentLoan}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </>
                            );
                          });
                        }
                      } else {
                        if (
                          Number(gracePeriod) === 0 &&
                          discountFields.length === 0
                        ) {
                          return arrayLength?.map((_, index) => {
                            const last = index + 1 === arrayLength.length;
                            if (index === 0) currentLoan = loan;
                            const monthlyInterestRate =
                              interestRate / 100 / deadline;

                            const averageAmortizationRate =
                              (Math.pow(1 + monthlyInterestRate, deadline) *
                                monthlyInterestRate) /
                              (Math.pow(1 + monthlyInterestRate, deadline) - 1);

                            const currentPrincipalAndInterest = Math.ceil(
                              loan * averageAmortizationRate
                            );

                            const currentInterest = Math.round(
                              currentLoan * monthlyInterestRate
                            );
                            const currentPrincipal =
                              currentPrincipalAndInterest - currentInterest;

                            totalInterest += currentInterest;

                            const currentRepayment = last
                              ? currentLoan + currentInterest
                              : currentPrincipal + currentInterest;
                            if (!last)
                              currentLoan = currentLoan - currentPrincipal;
                            return (
                              <TableRow>
                                <TableCell align={"center"}>
                                  {index + 1}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {last ? currentLoan : currentPrincipal}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentInterest}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentRepayment}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {last ? 0 : currentLoan}
                                </TableCell>
                              </TableRow>
                            );
                          });
                        } else if (
                          Number(gracePeriod) !== 0 &&
                          discountFields.length === 0
                        ) {
                          return arrayLength?.map((_, index) => {
                            const last = index + 1 === arrayLength.length;
                            const graceDuring =
                              index + 1 <= Number(gracePeriod);
                            if (graceDuring) currentLoan = loan;

                            const monthlyInterestRate =
                              interestRate / 100 / deadline;

                            const averageAmortizationRate = graceDuring
                              ? (Math.pow(1 + monthlyInterestRate, deadline) *
                                  monthlyInterestRate) /
                                (Math.pow(1 + monthlyInterestRate, deadline) -
                                  1)
                              : (Math.pow(
                                  1 + monthlyInterestRate,
                                  Number(deadline) - Number(gracePeriod)
                                ) *
                                  monthlyInterestRate) /
                                (Math.pow(
                                  1 + monthlyInterestRate,
                                  Number(deadline) - Number(gracePeriod)
                                ) -
                                  1);

                            const currentPrincipalAndInterest = Math.ceil(
                              loan * averageAmortizationRate
                            );
                            const currentInterest = Math.round(
                              currentLoan * monthlyInterestRate
                            );
                            const currentPrincipal = graceDuring
                              ? 0
                              : last
                              ? currentLoan
                              : currentPrincipalAndInterest - currentInterest;
                            totalInterest += currentInterest;
                            const currentRepayment =
                              currentPrincipal + currentInterest;

                            currentLoan = currentLoan - currentPrincipal;

                            return (
                              <TableRow>
                                <TableCell align={"center"}>
                                  {index + 1}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {graceDuring ? 0 : currentPrincipal}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentInterest}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {currentRepayment}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {graceDuring ? loan : currentLoan}
                                </TableCell>
                              </TableRow>
                            );
                          });
                        } else if (discountFields.length > 0) {
                          currentLoan = loan;
                          let duringArray = [];
                          let totalLength = 0;
                          arrayLength.forEach((item) => {
                            totalLength += item.data?.length;
                          });
                          for (let index = 1; index <= totalLength; index++) {
                            duringArray.push(index);
                          }
                          return arrayLength?.map((item, index) => {
                            return (
                              <>
                                <TableRow>
                                  <TableCell
                                    align={"center"}
                                    colSpan={5}
                                    style={{
                                      color: "white",
                                      backgroundColor: "#103775",
                                    }}
                                  >
                                    {`以下利率為${item.interestRate}%`}
                                  </TableCell>
                                </TableRow>
                                {item.data?.map((item2, index2) => {
                                  const graceDuring = item2.gracePeriod;
                                  let period = null;
                                  period = duringArray.shift();
                                  const monthlyInterestRate =
                                    item.interestRate / 100 / deadline;

                                  const averageAmortizationRate = graceDuring
                                    ? (Math.pow(
                                        1 + monthlyInterestRate,
                                        deadline
                                      ) *
                                        monthlyInterestRate) /
                                      (Math.pow(
                                        1 + monthlyInterestRate,
                                        deadline
                                      ) -
                                        1)
                                    : (Math.pow(
                                        1 + monthlyInterestRate,
                                        Number(deadline) - Number(gracePeriod)
                                      ) *
                                        monthlyInterestRate) /
                                      (Math.pow(
                                        1 + monthlyInterestRate,
                                        Number(deadline) - Number(gracePeriod)
                                      ) -
                                        1);

                                  if (graceDuring) currentLoan = loan;
                                  const currentPrincipalAndInterest = Math.ceil(
                                    loan * averageAmortizationRate
                                  );
                                  const currentInterest = Math.round(
                                    currentLoan * monthlyInterestRate
                                  );
                                  const currentPrincipal = graceDuring
                                    ? 0
                                    : duringArray.length === 0
                                    ? currentLoan
                                    : currentPrincipalAndInterest -
                                      currentInterest;
                                  totalInterest += currentInterest;
                                  const currentRepayment =
                                    duringArray.length === 0
                                      ? currentLoan + currentInterest
                                      : currentPrincipal + currentInterest;
                                  if (duringArray.length !== 0) {
                                    currentLoan =
                                      currentLoan - currentPrincipal;
                                  }

                                  return (
                                    <TableRow>
                                      <TableCell align={"center"}>
                                        {period}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {graceDuring
                                          ? 0
                                          : duringArray.length === 0
                                          ? currentLoan
                                          : currentPrincipal}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {currentInterest}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {currentRepayment}
                                      </TableCell>
                                      <TableCell align={"center"}>
                                        {graceDuring
                                          ? loan
                                          : duringArray.length === 0
                                          ? 0
                                          : currentLoan}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </>
                            );
                          });
                        }
                      }
                    })()}
                    <TableRow>
                      <TableCell align={"center"}>總計</TableCell>
                      <TableCell align={"center"}>{loan}</TableCell>
                      <TableCell align={"center"}>{totalInterest}</TableCell>
                      <TableCell align={"center"}>
                        {Number(loan) + Number(totalInterest)}
                      </TableCell>
                      <TableCell align={"center"}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
          )}
        </Dialog>
      </Grid>
    </Grid>
  );
}

// --------------
//ANCHOR 搜尋
function SearchForm({ props }) {
  const { setSearch, setSearchData } = props;
  const history = useHistory();
  const isPhone5 = useMediaQuery("(max-width:320px)");
  const isPhone = useMediaQuery("(max-width:376px)");
  const isPad = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
      minHeight: "400px",
    },
    backImg: {
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    contentBox: {
      justifyContent: "center",
    },
    selectBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      backgroundColor: "white",
      height: isPhone ? "45px" : isPad ? "55px" : "65px",
      borderRadius: isPhone ? "22px" : isPad ? "30px" : "35px",
      marginBottom: "10px",
    },
    selectGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRight: "1px solid black",
    },
    select: {
      lineHeight: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      backgroundColor: "transparent",
      padding: isPhone ? "0px 10px" : "0px 20px",
      fontSize: isPhone ? "0.75rem" : "1rem",
      width: isPhone5
        ? "35px"
        : isPhone
        ? "35px"
        : isPad
        ? "50px"
        : isTable
        ? "75px"
        : "100px",
      height: isPhone ? "30px" : isPad ? "25px" : isTable ? "25px" : "30px",
      textOverflow: "ellipsis",
      "&.MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
    },
    buttonBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px",
    },
    button: {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
      width: isPhone ? "170px" : isPad ? "200px" : isTable ? "250px" : "270px",
      height: isPhone ? "40px" : isPad ? "45px" : isTable ? "50px" : "55px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
      borderRadius: isPhone
        ? "20px"
        : isPad
        ? "23px"
        : isTable
        ? "25px"
        : "100px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    change: {
      color: theme.palette.secondary.light,
      margin: "10px 0px",
      fontSize: isPhone ? "18px" : isPad ? "20px" : isTable ? "22px" : "27px",
    },
    checkBox: {
      color: "lightgrayblue",
      marginLeft: "15px",
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
      },
      "&:not($checked) .MuiIconButton-label:after": {
        content: '""',
        left: 5,
        top: 5,
        height: "20px",
        width: "20px",
        position: "absolute",
        backgroundColor: "white",
        zIndex: -1,
      },
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: theme.palette.primary.main,
      },
      "& .MuiSvgIcon-root": {
        height: "30px",
        width: "30px",
      },
    },
  }));
  const classes = useStyles();

  const { watch, register } = useForm();
  let city = Object.keys(divisions);
  const [selectDistrict, setSelectDistrict] = useState();
  const { typeArray } = searchDataArray();
  const [type, setType] = useState(["土地", "建物"]);
  const typeChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setType(type.length === typeArray.length ? [] : typeArray);
      return;
    }
    setType(value);
  };
  return (
    <Box className={classes.backBox}>
      {/* Select 查詢 */}
      <Box mt={2} mb={12}>
        <Grid container>
          <Grid container item xs={12} justify="center">
            <Box mb={0}>
              <Typography variant="h2">
                Find THE BEST PLACE TO INVEST
              </Typography>
              <Typography variant="h4">找尋最佳投資地點</Typography>
            </Box>
          </Grid>
          <Grid
            container
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container item xs={12} lg={10} className={classes.contentBox}>
              <Grid
                container
                item
                xs={11}
                sm={9}
                md={7}
                lg={7}
                className={classes.selectBox}
              >
                <Grid item xs={3} lg={3} className={classes.selectGrid}>
                  <Select
                    native
                    {...register("district")}
                    classes={{ root: classes.select }}
                    disableUnderline
                    onChange={(e) => {
                      setSelectDistrict(
                        divisions[city[e.target.selectedIndex - 1]].subdivisions
                      );
                    }}
                  >
                    <option disabled selected value="">
                      縣市
                    </option>
                    {Object.keys(divisions).map((item, index) => (
                      <option key={item}>{divisions[city[index]].zhTW}</option>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={3} lg={3} className={classes.selectGrid}>
                  <Select
                    native
                    {...register("subdistrict")}
                    classes={{ root: classes.select }}
                    disableUnderline
                  >
                    <option disabled selected value="">
                      鄉鎮/區域
                    </option>
                    {selectDistrict !== undefined
                      ? Object.keys(selectDistrict)
                          .map((item) => selectDistrict[item].zhTW)
                          .map((item, index) => (
                            <option key={item}>{item}</option>
                          ))
                      : null}
                  </Select>
                </Grid>
                <Grid item xs={3} lg={3} className={classes.selectGrid}>
                  <Select
                    multiple
                    disableUnderline
                    {...register("type")}
                    onChange={typeChange}
                    displayEmpty={true}
                    value={type}
                    classes={{ root: classes.select }}
                    renderValue={
                      type.length === 0
                        ? () => "物件類型"
                        : (selected) => selected.join(", ")
                    }
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                    }}
                  >
                    <MenuItem key="全選" value="全選">
                      <FormControlLabel
                        control={
                          <Checkbox
                            className={classes.checkBox}
                            checked={
                              typeArray.length > 0 &&
                              type.length === typeArray.length
                            }
                            indeterminate={
                              type.length > 0 && type.length < typeArray.length
                            }
                          />
                        }
                        label={
                          <Typography variant="subtitle1">全選</Typography>
                        }
                      />
                    </MenuItem>
                    {typeArray.map((item) => (
                      <MenuItem key={item} value={item}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className={classes.checkBox}
                              checked={type.indexOf(item) > -1}
                            />
                          }
                          label={
                            <Typography variant="subtitle1">{item}</Typography>
                          }
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={12} className={classes.buttonBox}>
                <Button
                  className={classes.button}
                  startIcon={<SearchIcon style={{ fontSize: "28px" }} />}
                  onClick={() => {
                    history.push("/search?searchType=easy", {
                      district: watch("district"),
                      subdistrict: watch("subdistrict"),
                      type,
                    });
                  }}
                >
                  查詢
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
